import {
  CreditCardToken,
  DebitToken,
  Endpoint,
  GetChallengeRequest,
  GetChallengeResponse,
} from '../class/class';
import { SigningMethod } from '../enums/const-enums';
import { initialStore } from '../redux/store';
import {
  handleMethodAndChallengeData,
  httpRequest,
  logd,
  removeSpaces,
} from '../utils/utils';

export class GetChallenge extends Endpoint {
  static endpoint = 'qsl_sign_get_challenge';

  constructor() {
    super();
  }

  async doGetChallenge(): Promise<GetChallengeResponse> {
    const req = GetChallenge.getChallengeRequest;
    logd(() =>
      console.log('%c doGetChallenge -> %c', 'color:#F60', 'color:#000', req),
    );
    const resp = await httpRequest<GetChallengeResponse>(
      `${this.baseUrl}${GetChallenge.endpoint}`,
      req,
    );
    const getChallengeResponse = new GetChallengeResponse(resp.json);
    handleMethodAndChallengeData(getChallengeResponse);
    return getChallengeResponse;
  }

  private static get getChallengeRequest(): GetChallengeRequest {
    const state = initialStore.getState();
    return new GetChallengeRequest(
      state.methods.allowedSignMethods,
      state.methods.preferredSignMethod,
      [SigningMethod.RABO_SCANNER, SigningMethod.RANDOM_READER].includes(
        state.methods.activeSignMethod,
      ) && state.card.creditCardType === null
        ? new DebitToken(
            removeSpaces(state.card.accountNumber),
            state.card.cardNumber,
          )
        : undefined,
      [SigningMethod.RABO_SCANNER, SigningMethod.RANDOM_READER].includes(
        state.methods.activeSignMethod,
      ) && state.card.creditCardType !== null
        ? new CreditCardToken(state.card.creditCardType, state.card.cardNumber)
        : undefined,
    );
  }
}
